import { render } from "./TextBlock.vue?vue&type=template&id=4e7a2362"
const script = {}

import "./TextBlock.vue?vue&type=style&index=0&id=4e7a2362&lang=stylus"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__